import * as Yup from 'yup';
import { BILLING_ADDRESS_REGEX, NAME_ON_CARD_REGEX, NICKNAME_REGEX, NON_DIGITS_REGEX, ZIPCODE_REGEX, } from '../../../constants/regex';
import { CARD_HOLDER_NAME_REQUIRED, CARD_BILLING_ADDRESS_REQUIRED, ZIP_CODE_REQUIRED, ZIP_CODE_INVALID, CARD_EXP_YEAR_REQUIRED, CARD_EXP_MONTH_REQUIRED, CARD_HOLDER_NAME_INVALID, BILLING_ADDRESS_INVALID, NICKNAME_INVALID, CARD_HOLDER_NAME_TOO_LONG, CARD_ADDRESS_REQUIRED, } from '../../../constants/field-error-messages';
import { ERR_ZIPCODE_FIND } from '../../../constants/response-error-messages';
const expirationDateValidator = (month, year) => {
    if (!month || !year) {
        return false;
    }
    const monthNumber = parseInt(month, 10);
    const yearNumber = parseInt(year, 10);
    const lastDayOfMonth = new Date(yearNumber, monthNumber, 0);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset the time to the start of the day
    return lastDayOfMonth >= currentDate;
};
const commonRule = {
    isHDCard: Yup.boolean(),
    cardNickName: Yup.string().trim().matches(NICKNAME_REGEX, {
        message: NICKNAME_INVALID.message,
    }),
    cardHolderName: Yup.string()
        .trim()
        .required(CARD_HOLDER_NAME_REQUIRED.message)
        .max(100, CARD_HOLDER_NAME_TOO_LONG.message)
        .matches(NAME_ON_CARD_REGEX, {
        message: CARD_HOLDER_NAME_INVALID.message,
        excludeEmptyString: true,
    }),
    cardExpiryMonth: Yup.string().when('isHDCard', {
        is: false,
        then: Yup.string()
            .required(CARD_EXP_MONTH_REQUIRED.message)
            .test('is-expiration-date-valid', CARD_EXP_MONTH_REQUIRED.message, function (value) {
            const { cardExpiryYear } = this.parent;
            return expirationDateValidator(value, cardExpiryYear);
        }),
    }),
    cardExpiryYear: Yup.string().when('isHDCard', {
        is: false,
        then: Yup.string()
            .required(CARD_EXP_YEAR_REQUIRED.message)
            .test('is-expiration-date-valid', CARD_EXP_YEAR_REQUIRED.message, function (value) {
            const { cardExpiryMonth } = this.parent;
            return expirationDateValidator(cardExpiryMonth, value);
        }),
    }),
};
export const b2bValidationSchema = Yup.object().shape(Object.assign(Object.assign({}, commonRule), { addressLine1: Yup.string()
        .trim()
        .required(CARD_BILLING_ADDRESS_REQUIRED.message)
        .matches(BILLING_ADDRESS_REGEX, {
        message: BILLING_ADDRESS_INVALID.message,
    }), addressLine2: Yup.string().trim().matches(BILLING_ADDRESS_REGEX, {
        message: BILLING_ADDRESS_INVALID.message,
    }), zipCode: Yup.string()
        .when('isZipCodeNotFoundError', {
        is: true,
        then: Yup.string().matches(NON_DIGITS_REGEX, {
            message: ZIP_CODE_INVALID.message,
        }),
    })
        .when('isZipCodeApiError', {
        is: true,
        then: Yup.string().matches(NON_DIGITS_REGEX, {
            message: ERR_ZIPCODE_FIND.message,
        }),
    })
        .required(ZIP_CODE_REQUIRED.message)
        .matches(ZIPCODE_REGEX, { message: ZIP_CODE_INVALID.message }), isZipCodePending: Yup.boolean(), isZipCodeApiError: Yup.boolean() }));
export const b2cValidationSchema = Yup.object().shape(Object.assign(Object.assign({}, commonRule), { billingAddressID: Yup.number()
        .nullable()
        .required(CARD_ADDRESS_REQUIRED.message) }));
